angular.module('e360')
   .directive('countryStates', countryStatesDirective);

function countryStatesDirective() {
   return {
      restrict: 'A',
      controller: CountryStatesController,
      controllerAs: 'countryStatesCtrl',
      scope: true,
      bindToController: {
         onStateSelect: '&'
      }
   };
}

CountryStatesController.$inject = ['countryService'];
function CountryStatesController(countryService) {
   this.onCountryChange = onCountryChange;
   this.countries = [];
   this.countryCode = null;

   Object.defineProperty(this, 'states', {
      get: statesGetter
   });

   var self = this;
   countryService.list().then(function(countries) {
      self.countries = countries;
   });

   function onCountryChange(countryCode) {
      this.countryCode = countryCode;
   }

   function statesGetter() {
      var country = _.findWhere(this.countries, {code: this.countryCode});
      return country ? country.states : [];
   }
}
